'use strict';

function AnnotationLayerEditorDirective ($compile, $timeout, $templateCache, AnnotationStore) {

  const link = (scope, element, attrs, ctrls) => {

    const AnnotationLayerController = ctrls[0];
    const MapCtrl = ctrls[1];
    const activeLayer = MapCtrl.activeLayer;

    if (!MapCtrl) {
      console.warn('Error: No MapCtrl required controller found');
      return;
    }

    // IMPORTANT: Set the bound variable here
    AnnotationLayerController.annotationLayer = activeLayer;
    if (activeLayer && activeLayer.data.properties.style) {
      AnnotationLayerController.activeColor = activeLayer.data.properties.style.color;
    }

    if (activeLayer && activeLayer.data.properties.text) {
      AnnotationLayerController.text = activeLayer.data.properties.text;
    }

    if (activeLayer && activeLayer.data.properties.showMeasurements) {
      AnnotationLayerController.showMeasurements = true;
    }

    let template;
    if (activeLayer && activeLayer.type) {
      template = $templateCache.get(
        'dash/map/annotationLayerEditor/templates/annotationLayerEditor-' + activeLayer.type + '.tpl.html'
      );
      if (!template) {
        template = '<div>TEMPLATE NOT FOUND</div>';
      }
    }
    else {
      template = '<div>NOT ANY ACTIVE LAYER </div>';
    }

    if (activeLayer.type === 'text' || activeLayer.type === 'marker') {
      scope.$watch(() => {

        return AnnotationLayerController.text;
      }, (newText) => {

        const layer = MapCtrl.activeLayer;
        layer.data.properties.text = newText;
        MapCtrl.refreshLayerText(layer, newText);

        const newLayerName = AnnotationStore.getAnnotationLayerName(
          AnnotationLayerController.annotationLayer.data,
          AnnotationLayerController.annotationLayer.type,
          null,
          AnnotationLayerController.annotationLayer.label
        );
        AnnotationStore.renameAnnotationLayer(
          AnnotationLayerController.annotationLayer.id,
          newLayerName
        );

      });
    }

    AnnotationLayerController.refreshLayerStyle = (styleChanges) => {

      const layer = MapCtrl.activeLayer;
      MapCtrl.refreshLayerStyle(layer, styleChanges);
    };

    AnnotationLayerController.refreshShowMeasurements = (showMeasurements) => {

      const layer = MapCtrl.activeLayer;
      MapCtrl.refreshShowMeasurements(layer, showMeasurements);
    };

    element.html(template);

    if (activeLayer.type === 'text' || activeLayer.type === 'marker') {
      $timeout(() => {

        element[0].querySelector('[focus]').focus();
      }, 500);
    }

    $compile(element.contents())(scope);
  };

  return {
    bindToController: true,
    controller: 'AnnotationLayerEditorController',
    controllerAs: 'editorCtrl',
    link: link,
    template : '<div></div>',
    require: ['annotationLayerEditor', '^sbMap']
  };
}

AnnotationLayerEditorDirective.$inject = ['$compile', '$timeout', '$templateCache', 'AnnotationStore'];
module.exports = AnnotationLayerEditorDirective;



// WEBPACK FOOTER //
// ./src/app/dash/map/annotationLayerEditor/AnnotationLayerEditorDirective.js